import React from 'react'
import { Link } from 'react-router-dom'
import Button from '../../components/Form/button/Button'
import { Container } from './styles'


function ForgotSuccess(props) {
  return (
    <Container className="container col-md-5">
      <div className="row justify-content-center pt-5">
        <div className="form-group col-12 text-center mt-5">
          <h1>Solicitação realizada!</h1>
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-md-8 text-center">
          <h5 className="mt-5">Confira as informações para recuperar sua senha
        enviadas em seu e-mail</h5>
        </div>
      </div>
      <div className="col-sm mt-5 text-center mb-2">
        <Link to="/login">
          <Button
            type="submit"
            template="button1"
            bgColor="#00FFA0"
            color="#4e4e4e"
            className="btn btn-lg col-7 font-weight-bolder"
            label="Login" />
        </Link>
      </div>
    </Container >
  )
}
ForgotSuccess.defaultProps = {
  submit: Function,
  formRef: Function
}

export default ForgotSuccess